module.exports = __webpack_public_path__ + "img/backgroundimg.0e795c4a.jpg";